import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";

const LINKS = [
  { label: "Chi Siamo", target: "#chi-siamo", testid: "nav-chi-siamo-link" },
  { label: "Soluzioni", target: "#lavori", testid: "nav-soluzioni-link" },
  { label: "Come Funziona", target: "#come-funziona", testid: "nav-come-funziona-link" },
  { label: "Servizi", target: "#servizi", testid: "nav-servizi-link" },
  { label: "FAQ", target: "#faq", testid: "nav-faq-link" },
  { label: "Contatti", target: "#contatti", testid: "nav-contatti-link" },
];

export const Header = () => {
  const [time, setTime] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const tick = () =>
      setTime(new Date().toLocaleTimeString("it-IT", { timeZone: "Europe/Rome", hour: "2-digit", minute: "2-digit" }));
    tick();
    const id = setInterval(tick, 30000);
    return () => clearInterval(id);
  }, []);

  const go = (target) => {
    setOpen(false);
    scrollToSection(target);
  };

  return (
    <header data-testid="site-header" className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-[#FBF9F5]/80 border-b border-[#E5E2DC]">
      <div className="px-6 sm:px-12 lg:px-20 max-w-7xl mx-auto h-16 flex items-center justify-between">
        <button data-testid="brand-logo" onClick={() => go("#hero")} aria-label="Furlan Print Copy — Torna su">
          <img src="/logo.png" alt="Furlan Print & Copy — Noleggio e Assistenza Stampanti" className="h-12 w-auto rounded-sm" />
        </button>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.target}
              data-testid={l.testid}
              onClick={() => go(l.target)}
              className="text-sm text-[#6E6D69] hover:text-[#181817] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-6">
          <span data-testid="milano-time" className="font-mono text-xs tracking-[0.2em] text-[#6E6D69]">
            PADERNO D. {time}
          </span>
          <button
            data-testid="header-cta-button"
            onClick={() => { setOpen(false); window.dispatchEvent(new Event("open-quote-modal")); }}
            className="group flex items-center gap-1.5 bg-[#181817] text-[#FBF9F5] text-sm px-5 py-2.5 rounded-full hover:bg-[#C85A32] transition-colors duration-300"
          >
            Richiedi Preventivo
            <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>
        <button data-testid="mobile-menu-button" onClick={() => setOpen(!open)} className="md:hidden text-[#181817]" aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="md:hidden overflow-hidden border-t border-[#E5E2DC] bg-[#FBF9F5]"
          >
            <div className="px-6 py-8 flex flex-col gap-6">
              {LINKS.map((l, i) => (
                <button
                  key={l.target}
                  data-testid={`mobile-${l.testid}`}
                  onClick={() => go(l.target)}
                  className="text-left font-display text-3xl font-light text-[#181817]"
                >
                  <span className="font-mono text-xs text-[#C85A32] mr-3">0{i + 1}</span>
                  {l.label}
                </button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
